module.exports = __webpack_public_path__ + "img/myxy.1657189097237.png";